import './styles.css';

import { createRoot, type Root } from 'react-dom/client';

import InxsWeb from './components/inxs-web/InxsWeb';
import { getAppInsights, initAppInsights } from './helpers/telemetryHelper';

function setIdsFonts() {
  const id = 'inxs-web-ids-fonts';

  if (document.getElementById(id)) return;

  const style = document.createElement('style');
  style.id = id;
  style.textContent = `
    @font-face {
      font-family: "If Sans Variable";
      src:
        url("https://static.design.if.eu/ids-font/IfSans-Variable.woff2") format("woff2"),
        url("https://static.design.if.eu/ids-font/IfSans-Variable.woff") format("woff"),
        url("https://static.design.if.eu/ids-font/IfSans-Variable.ttf") format("truetype");
      font-weight: 100 900;
      font-style: normal;
      font-display: swap;
    }
  `;
  document.head.appendChild(style);
}

class InxsWebElement extends HTMLElement {
  private shadow: ShadowRoot;
  private mountPoint: HTMLDivElement;
  private root?: Root;

  constructor() {
    super();

    if (!getAppInsights()) {
      initAppInsights();
    }

    this.shadow = this.attachShadow({ mode: 'open' });
    this.mountPoint = document.createElement('div');
    this.mountPoint.style.height = '100%';
    this.shadow.appendChild(this.mountPoint);

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${import.meta.env.VITE_CDN_BASE_URL}/assets/index-${__COMMIT_HASH__}.css`;
    this.shadow.appendChild(link);
  }

  connectedCallback() {
    setIdsFonts();
    this.renderComponent();
  }

  disconnectedCallback() {
    this.root?.unmount();
  }

  attributeChangedCallback() {
    this.renderComponent();
  }

  private renderComponent() {
    if (!this.root) {
      this.root = createRoot(this.mountPoint);
    }

    this.root.render(<InxsWeb instanceId={this.id} shadowRoot={this.shadowRoot!} />);
  }
}

customElements.define('inxs-web', InxsWebElement);
